import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/opt/hotlistcasino/frontend/src/app/[lang]/contact/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/opt/hotlistcasino/frontend/src/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionReveal"] */ "/opt/hotlistcasino/frontend/src/components/MotionReveal.tsx");
